/* eslint-disable class-methods-use-this */
import React, {ReactNode} from 'react';
import {logWithSentry} from 'libs/sentry/sentry';

type PropsType = {
    fallback?: ReactNode;
};

type StateType = {
    hasError: Boolean;
};

/**
 * Catches JavaScript errors anywhere in their child component tree, log those errors, and display a fallback UI.
 * More details and examples: https://reactjs.org/docs/error-boundaries.html
 */
export class ErrorBoundary extends React.Component<PropsType, StateType> {
    static defaultProps = {
        fallback: null,
    };

    state = {hasError: false};

    /**
     * Update state so the next render will show the fallback UI.
     * @returns {StateType} updated state
     */
    static getDerivedStateFromError() {
        return {hasError: true};
    }

    /**
     * Logs error
     * @param {Error} error - error
     * @param {ErrorInfo} errorInfo - detailed description of the error
     */
    componentDidCatch(error, errorInfo) {
        logWithSentry(error, errorInfo);
    }

    /**
     * Renders children element if no error occurs during the process, otherwise "fallback" value
     * @returns {ReactNode} rendered content
     */
    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}
